import * as React from 'react'
import { Button } from 'react-bootstrap'
import Footer from 'components/Footer'
import HeaderLarge from 'components/HeaderLarge'
import Information from 'components/Information'

const SceneComponent: React.FC = () => {
  return (
    <>
      <HeaderLarge title="AUBEクエストコネクタープランのページへようこそ！" />
      <Information>
        <div>
          <div>AUBEクエストコネクターの登録サイトです。ご登録にはAUBEクエストID、報酬受取用の金融機関の口座情報が必要になりますのでご用意ください。</div>
          <div>手続きを進めてい行きますと本人確認用に下記の証明書の撮影が必要になります。</div>
          <div>・運転免許証</div>
          <div>・マイナンバーカード</div>
          <div>・在留カード</div>
          <div>・パスポート</div>
        </div>
        <div className="note-warning mt-3">
          <div>法人契約の場合</div>
          <div>発行後3ヶ月以内の登記事項証明書（履歴事項全部証明書）の全ページの画像をご用意ください。（画像1枚につき10M未満）</div>
        </div>
      </Information>
      <div className="mt-4">
        <Button variant="primary" className="w-100 py-4" href="/login">
          ログイン
        </Button>
      </div>
      <div className="mt-4">
        <Button variant="success" className="w-100 py-4" href="/contactUs">
          お問い合わせ
        </Button>
      </div>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
